import { Link } from '@iwoca/orion';
import { Trans } from '@lingui/macro';
import { deriveProductFromTypeAndDuration } from 'applicationTable/applicationUtils';
import { LoadingSpinner } from 'components/LoadingSpinner/LoadingSpinner';
import { ProductItems } from 'components/ProductItems/ProductItems';
import { useIntroducerContext } from 'contexts/IntroducerContext/IntroducerContext';
import { useAmplitude } from 'hooks/useAmplitude';
import { useLocale } from 'hooks/useLocale';
import { TSupportedProductTypes } from 'lendingApi/applications.types';
import { useNavigate } from 'react-router-dom';
import { PATH_NAMES } from 'utils/routes/pathNames';
import { AMPLITUDE_EVENTS } from 'utils/tracking/tracking.events';
import styles from './ProductsPageDE.module.css';

export const ProductsPageDE = () => {
  const navigate = useNavigate();
  const { trackEvent } = useAmplitude();
  const { isUK } = useLocale();
  const { introducerId, isContextError } = useIntroducerContext();

  const applyForProduct = (product: TSupportedProductTypes) => {
    trackEvent(AMPLITUDE_EVENTS.signupCTAClicked, {
      'CTA location': 'Products',
      'CTA text': `Apply for a ${
        deriveProductFromTypeAndDuration({ productType: product, isUK }).name
      }`,
      'CTA URL': PATH_NAMES.newApplicationStep0(),
    });

    return navigate(PATH_NAMES.newApplicationStep0());
  };

  if (!introducerId) {
    <LoadingSpinner />;
  }

  if (isContextError) {
    navigate(PATH_NAMES.notFound());
  }

  return (
    <>
      <ProductItems applyForProduct={applyForProduct} />
      {!isUK && (
        <Link
          className={styles.termsLink}
          href="https://uploads-ssl.webflow.com/62b040bf442187a12361b14f/66a35aebd157e3c2c4600c51_DE_AGB_-_update_v240618.pdf"
          target="_blank"
          rel="noreferrer"
        >
          <Trans>Terms and conditions</Trans>
        </Link>
      )}
    </>
  );
};
